module.exports = __webpack_public_path__ + "media/images/message-3f3ad6c5d062c17ae41b2f7e2b71f39c219694ce151f96d86166bf9ed10886ea.svg";